import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
var Link = styled.a.attrs(function () { return ({
    target: '_blank',
    rel: 'noopener noreferrer',
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: inherit;\n  text-decoration: underline;\n"], ["\n  color: inherit;\n  text-decoration: underline;\n"])));
var Root = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  white-space: pre-wrap;\n\n  p:first-child {\n    margin-top: 0;\n  }\n\n  div + div {\n    margin-top: 8px;\n  }\n"], ["\n  white-space: pre-wrap;\n\n  p:first-child {\n    margin-top: 0;\n  }\n\n  div + div {\n    margin-top: 8px;\n  }\n"])));
export var Linkify = function (_a) {
    var source = _a.source, linkStyle = _a.linkStyle, renderers = _a.renderers, props = __rest(_a, ["source", "linkStyle", "renderers"]);
    if (typeof source !== 'string') {
        throw new Error('Molekule: source prop must be a valid markdown string');
    }
    var markdownString = source.replace(/\r/g, '\n');
    return (React.createElement(ReactMarkdown, __assign({ source: markdownString, renderers: __assign({ paragraph: 'div', root: function (p) { return React.createElement(Root, __assign({}, p)); }, link: function (p) { return React.createElement(Link, __assign({}, p, { style: linkStyle })); }, code: function (_a) {
                var value = _a.value;
                return React.createElement("div", null, value);
            } }, renderers) }, props)));
};
Linkify.defaultProps = {
    className: 're-linkify',
    renderers: {},
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Linkify.js.map